import { SearchKeywords } from "@nosto/nosto-js/client";
import Keyword from "@/components/Autocomplete/Item/Keyword";

export type KeywordsProps = {
  keywords: SearchKeywords;
};

export default function Keywords({ keywords }: KeywordsProps) {
  if (!keywords?.hits?.length) {
    return null;
  }

  return (
    <>
      <h4>Related Search</h4>
      <div>
        {keywords.hits.map((keyword, index) => (
          <Keyword key={index} keyword={keyword} />
        ))}
      </div>
    </>
  );
}
